var map = {
	"./applab/skins": 2154,
	"./bounce/skins": 2522,
	"./craft/agent/skins": 2526,
	"./craft/code-connection/skins": 2527,
	"./craft/designer/skins": 2525,
	"./craft/simple/skins": 2524,
	"./flappy/skins": 2528,
	"./jigsaw/skins": 2541,
	"./maze/skins": 1810,
	"./netsim/skins": 2548,
	"./p5lab/skins": 2020,
	"./studio/skins": 2550,
	"./studio/starwars/skins": 2175,
	"./turtle/skins": 2214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3889;